const pagesGAOperationCoreOperationPackagesEn = {
  gaOperationCore: "GA Operation Core",
  startNew: "Create New",
  addPattern: "Add Pattern",
  equipment: "Equipment",
  progress: "Progress",
  viewData: "View Data",
  completed: "Completed",
  invalid: "Invalid",
  emptyInstanceTitle: "No running instances",
  emptyInstanceDescription: "Create a new instance",
  emptyPackagePatternTitle: "No operation package patterns",
  emptyPackagePatternDescription:
    "Please register from the 'Add Operation Package Pattern' button.",
  failedToGenerateEquipmentLabel: "Failed to generate equipment label",
  taskProgress: "Task Progress",
  start: "Start",
  successToCompleteTask: "Task completed successfully",
  failedToCompleteTask: "Failed to complete task",
  markAsComplete: "Mark as Complete",
  tabs: {
    operationPackages: "Operation Packages",
    archive: "Archive",
    config: "Configuration",
  },
  patternEmptyState: {
    title: "No operation package patterns",
    description:
      "Please register from the 'Add Operation Package Pattern' button.",
    action: "Add Operation Package Pattern",
  },
  taskEmptyState: {
    title: "No tasks",
    description: "Click 'Create New' to start a new task.",
  },
  status: {
    todo: "Prerequisite tasks incomplete",
    completed: "Completed",
    attachment: "Attachment",
    approval: "Approval",
    approvalRequired: "Approval Required",
    notRequired: "Not Required",
  },
  displayDataAggregate: "Display: Data Aggregate",
  instancesCount: "{{count}} instances",
  startOperationTaskDialog: {
    title: "Create New",
    description:
      "Select a target person and anchor date to start the operation.",
    targetPerson: "Target Person",
    targetEquipment: "Target Equipment",
    selectPerson: "Select Person",
    personSearchPlaceholder: "Search by name or email",
    equipmentSearchPlaceholder: "Search by equipment name or asset tag",
    filterEquipments: "Search by equipment name or asset tag",
    personRequired: "Please select a person",
    equipmentRequired: "Please select equipment",
    equipmentInventoryLabelDescription:
      "Configure settings for equipment inventory label issuance.",
    equipmentSelectionMode: {
      allUnissued: "All unissued equipment",
      selected: "Selected equipment",
    },
    cancelButtonLabel: "Cancel",
    startButtonLabel: "Start",
    creationFailed: "Failed to create operation instance",
    anchorDate: "Anchor Date",
    cancel: "Cancel",
    start: "Start",
  },
};

export default pagesGAOperationCoreOperationPackagesEn;
